import React, { useState } from 'react';
import { Button } from '@kiiwi/ui';
import { CardHcd } from '@maiia/model/generated/model/api-patient/api-patient';
import List from '../../organisms/SearchResults/List';
import { useTranslation } from '@/src/i18n';
import ListHeader from '@/components/organisms/SearchResults/ListHeader';
import FontAwesomeIcon from '@/components/atoms/FontawesomeIcon/FontawesomeIcon';
import { SEARCH_COUNT_PER_PAGE_V2 } from '@/src/constants';

type Props = {
  practitioners: (CardHcd | undefined)[];
  total: number;
  hasNextPage: boolean;
  fetchNextPage: () => void;
  titleKey: string;
  subtitleKey: string;
  mustHideSectorCard?: boolean;
  indexItemForSectorCard?: number;
};

/* Component */
const ImmediateTLCs = ({
  practitioners,
  total,
  hasNextPage,
  fetchNextPage,
  titleKey,
  subtitleKey,
  mustHideSectorCard,
  indexItemForSectorCard,
}: Props) => {
  const { t } = useTranslation();
  const [isListRetracted, setIsListRetracted] = useState<boolean>(false);

  const mustShowMorePractitionersButton = isListRetracted || hasNextPage;

  const showMoreOrLessPractitioners = () => {
    if (hasNextPage) {
      fetchNextPage();
    } else {
      setIsListRetracted(!isListRetracted);
    }
  };

  return (
    <div>
      <div className="flex h-auto flex-col gap-3">
        <List
          items={
            !isListRetracted
              ? practitioners
              : practitioners.slice(0, SEARCH_COUNT_PER_PAGE_V2)
          }
          mode="tlc"
          mustHideSectorCard={mustHideSectorCard}
          header={<ListHeader titleKey={titleKey} subtitleKey={subtitleKey} />}
          indexItemForSectorCard={indexItemForSectorCard}
        />
      </div>
      <div className="flex flex-col">
        {total > SEARCH_COUNT_PER_PAGE_V2 && (
          <Button
            variant="ghost"
            size="md"
            className="mx-auto mt-6 sm:mt-8"
            onClick={showMoreOrLessPractitioners}
          >
            {t(mustShowMorePractitionersButton ? 'show_more' : 'show_less')}
            <FontAwesomeIcon
              className="ml-2 !h-4 !w-4"
              name={
                mustShowMorePractitionersButton
                  ? 'angle-down:regular'
                  : 'angle-up:regular'
              }
            />
          </Button>
        )}
      </div>
    </div>
  );
};

export default ImmediateTLCs;
